//Dev
//export const ApiRepos = "https://localhost:5001/api/";
//Production
export const ApiRepos = "https://dashboard.motorent.biz/api/";